import React, { useState, useEffect } from 'react';
import { Clock, AlertTriangle } from 'lucide-react';

const SessionTimer = ({ timeRemaining, onTimeUp }) => {
  const [isWarning, setIsWarning] = useState(false);
  const [isCritical, setIsCritical] = useState(false);

  useEffect(() => {
    // Visual warnings based on remaining time
    if (timeRemaining <= 30) {
      setIsCritical(true);
      setIsWarning(false);
    } else if (timeRemaining <= 60) {
      setIsWarning(true);
      setIsCritical(false);
    } else {
      setIsWarning(false);
      setIsCritical(false);
    }

    // Handle session end
    if (timeRemaining <= 0 && onTimeUp) {
      onTimeUp();
    }
  }, [timeRemaining, onTimeUp]);

  const formatTime = () => {
    const minutes = Math.floor(timeRemaining / 60);
    const seconds = timeRemaining % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const getProgressPercentage = () => {
    return ((300 - timeRemaining) / 300) * 100;
  };

  const getTimerClassName = () => {
    let className = 'flex items-center space-x-3';
    return className;
  };

  const getTimeClassName = () => {
    if (isCritical) {
      return 'text-red-300 animate-pulse';
    } else if (isWarning) {
      return 'text-yellow-300';
    }
    return 'text-white';
  };

  return (
    <div className={getTimerClassName()}>
      {/* Timer Icon */}
      <div className={`p-2 rounded-full ${
        isCritical ? 'bg-red-500/20' : isWarning ? 'bg-yellow-500/20' : 'bg-white/20'
      }`}>
        {isCritical ? (
          <AlertTriangle className={`h-5 w-5 ${getTimeClassName()}`} />
        ) : (
          <Clock className={`h-5 w-5 ${getTimeClassName()}`} />
        )}
      </div>
      
      {/* Timer Display */}
      <div className="text-center">
        <div className={`text-2xl font-bold font-mono ${getTimeClassName()}`}>
          {formatTime()}
        </div>
        <div className="text-xs text-white/80">
          remaining
        </div>
      </div>
      
      {/* Progress Bar */}
      <div className="w-20 bg-white/20 rounded-full h-2 overflow-hidden">
        <div 
          className={`h-full transition-all duration-1000 ${
            isCritical ? 'bg-red-400' : isWarning ? 'bg-yellow-400' : 'bg-green-400'
          }`}
          style={{ width: `${getProgressPercentage()}%` }}
        />
      </div>
      
      {/* Warning Message */}
      {isCritical && (
        <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 bg-red-500/90 text-white px-3 py-1 rounded-full text-xs whitespace-nowrap">
          ⚠️ Session ending soon!
        </div>
      )}
    </div>
  );
};

export default SessionTimer;